import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { TRAINING_URL } from '../shared/src/lib/shared';
import { ErrorHandlerService } from './error-handler.service';

export interface SavePublicQuizUserRequest {
    userName: string;
    storeName: string;
    encryptedText: string;
}

export interface JoinQuizRequest {
    encryptedText: string;
    quizTypeId?: number;
    refId?: number;
}

export interface JoinQuizResponse {
    title: string;
    duration: number;
    trainingDuration?: number | null;
    questionList: any[];
    /** Training entity status; 3 = completed (post-test allowed). */
    trainingStatusId?: number | null;
    isTraining?: boolean;
    quizTypes?: Array<{
        id: number;
        name: string;
        isSubmit?: boolean;
        duration?: number | null;
        durationName?: string | null;
        endDate?: string | null;
        endTime?: string | null;
    }>;
}

export interface SubmitQuizRequest {
    encryptedText: string;
    accountId?: number;
    questionAnswers: Array<{
        questionId: number;
        answerId: number[];
    }>;
    userName: string;
    storeName: string;
}

export interface SaveUserResponse {
    success: boolean;
    message: string;
    refId: number;
}

export interface SubmitQuizResponse {
    message: string;
    refId: number;
}

export interface SaveQuestionAnswersForTrainingRequest {
    qTypeId: number;
    encryptedText: string;
    refId: number;
    questionAnswers: Array<{
        questionId: number;
        answerId: number[];
    }>;
}

export interface QuizResultAnswer {
    id: number;
    text: string;
    isCorrect: boolean;
    userSelected: boolean;
}

export interface QuizResultQuestion {
    questionId: number;
    text: string;
    isMultipleSelection: boolean;
    answers: QuizResultAnswer[];
}

export interface QuizResultsByTrainingTypeResponse {
    score: {
        correct: number;
        total: number;
        percentage: number;
    };
    duration?: unknown;
    questions: QuizResultQuestion[];
}

export interface GetQuizResultsByTrainingTypeRequest {
    encryptedText: string;
    refId: number;
    quizTypeId: number;
}

@Injectable({ providedIn: 'root' })
export class PublicLiveQuizService {
    private readonly BASE_URL = `${TRAINING_URL}/publicLiveQuiz`;

    constructor(private http: HttpClient, private errorHandler: ErrorHandlerService) { }

    joinQuiz(payload: JoinQuizRequest): Observable<JoinQuizResponse> {
        return this.http
            .post<JoinQuizResponse>(`${this.BASE_URL}/joinQuiz`, payload)
            .pipe(catchError(this.errorHandler.handleError));
    }

    submitQuiz(payload: SubmitQuizRequest): Observable<SubmitQuizResponse> {
        return this.http
            .post<SubmitQuizResponse>(`${this.BASE_URL}/submitQuiz`, payload)
            .pipe(catchError(this.errorHandler.handleError));
    }

    saveUser(payload: SavePublicQuizUserRequest): Observable<SaveUserResponse> {
        return this.http
            .post<SaveUserResponse>(`${this.BASE_URL}/saveUser`, payload)
            .pipe(catchError(this.errorHandler.handleError));
    }

    saveQuestionAnswersForTraining(payload: SaveQuestionAnswersForTrainingRequest): Observable<any> {
        return this.http
            .post(`${this.BASE_URL}/saveQuestionAnswersforTraining`, payload)
            .pipe(catchError(this.errorHandler.handleError));
    }

    getQuizResultsByTrainingType(payload: GetQuizResultsByTrainingTypeRequest): Observable<QuizResultsByTrainingTypeResponse> {
        return this.http
            .post<QuizResultsByTrainingTypeResponse>(`${this.BASE_URL}/getQuizResultsByTrainingType`, payload)
            .pipe(catchError(this.errorHandler.handleError));
    }


}


